const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/", "/mint"],
    exact: true,
    component: "Mint",
  },
];

export default routes;
